import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from 'components/v2/panels/Card';
import CardHeader from 'components/v2/panels/CardHeader';
import CardFooter from 'components/v2/panels/CardFooter';
import EditButton from 'components/v2/buttons/EditButton';
import { useTranslation } from 'react-i18next';

export default function EditableSection({
  className,
  children,
  title,
  canEdit,
  onCancel = () => {},
}) {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation();

  function setEditMode() {
    setEditing(true);
  }
  function cancelEditMode() {
    setEditing(false);
    onCancel();
  }

  function renderHeader() {
    return (
      <CardHeader title={title}>
        {!editing && canEdit && (
          <EditButton size="small" color="blue" onClick={setEditMode} />
        )}
      </CardHeader>
    );
  }

  function handleSaveSuccess() {
    setSaving(false);
    cancelEditMode();
  }

  function handleSaveFail() {
    setSaving(false);
  }

  function handleActionClick() {
    setSaving(true);
  }

  function renderFooter() {
    if (!editing || !canEdit) {
      return null;
    }
    return (
      <CardFooter
        onActionClick={handleActionClick}
        onCancelClick={cancelEditMode}
        actionLabel={t('SAVE')}
        cancelLabel={t('CANCEL')}
      />
    );
  }
  return (
    <Card
      header={renderHeader}
      footer={renderFooter}
      className={classNames(className)}
    >
      {children(
        editing,
        saving,
        handleSaveSuccess,
        handleSaveFail,
        cancelEditMode,
      )}
    </Card>
  );
}

EditableSection.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  children: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
};

EditableSection.defaultProps = {
  canEdit: false,
};
